import React, {useState} from "react";

const SplashScreen = (props) => {
    const numImages = props.data.level.reduce((numImages, level) => numImages + level.images.length, 0);
    const numVideos = props.data.level.reduce((numVideos, level) => numVideos + level.video_marker.length, 0);
    const numPlans = props.data.level.reduce((numPlans, level) => numPlans + level.plan_level.length, 0);
    const numPanelums = props.data.level.reduce((numPlans, level) => numPlans + level.panelum.length, 0);
    const [coverImage, setCoverImage] = useState(props.data.splash_screen ? `${props.data.splash_screen}` : "/static/public/img/default_cover_image.jpeg");

    return (
        <div className="splash_screen" style={{backgroundColor: props.data.bgColor}}>
            <div className="img_box">
                <img className={props.showHint ? "splash_img" : "splash_img_big"}
                    onLoad={(img) => {
                        props.setFinishLoadSplashScreen(true);
                    }}
                    src={coverImage}
                />
            </div>
            <div className="info_for_ifloorplan">
                <div className="address_ifi">{props.data.address}</div>
            </div>
            <div className="loader-overlay">
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="loader-txt">Virtual tour loading</div>
            </div>
        </div>
    );
};
export default SplashScreen;